$(document).ready(function() {

    $('.open_calculator').click(function(event) {
        $('#leasing_calc').css('display', 'block').animate({
            width: '100%'
        }, 400, function() {
            toCountHRV();
            toCountStandart();
        });

        if ($(window).width() < 991) {
            $('html, body').animate({
                scrollTop: 0
            }, 300);
        }
    });

    $('.close_calculator').click(function(event) {
        $('#leasing_calc').animate({
            width: '0'
        }, 400, function() {
            $(this).css('display', 'none');
        });
    });

    var changeCalc = $('.change_calculate .btn_change_calc');

    changeCalc.click(function(event) {
        $('.btn_change_calc').removeClass('active');
        $(this).addClass('active');
        if (changeCalc.hasClass('active')) {
            $('.calculator').removeClass('open')
            $('#' + $(this).attr('rel')).addClass('open');
        }
        toCountHRV();
        toCountStandart();
        toCountCredit();
        toCountLoan();
    });

    function getMonthlyPaymentCredit(result, rateResult, table, months, downPayment) {
        let downPaymentIndex = downPayment / 5;
        let cell = table[months][downPaymentIndex];
        let [price, rate] = cell.split(", ");

        result.text(price);
        rateResult.text(rate);
    }


    function getMonthlyPayment(result, table, months, downPayment) {
        let downPaymentIndex = downPayment / 5;
        let monthlyPayment = table[months][downPaymentIndex];
        result.text(monthlyPayment);
    }

    function toCountHRV() {
        var pathName = window.location.pathname;
        if ($('#calculateRateHRV').hasClass('open')) {
            var result = $('#monthlyPaymentHRV');

            if (pathName.includes('baic-7')) {
                var leasingHRVTable = {
                    '24': [2978, 2674, 2371, 2067, 1764, 1460, 1156],
                    '36': [2407, 2196, 1999, 1772, 1561, 1349, 1137],
                    '48': [2160, 1994, 1828, 1662, 1496, 1330, 1165],
                    '60': [2245, 2107, 1968, 1829, 1691, 1552, 1413]
                };

            }
            if (pathName.includes('baic-5')) {
                var leasingHRVTable = {
                    '24': [2338, 2100, 1861, 1623, 1385, 1146, 908],
                    '36': [2016, 1850, 1690, 1517, 1351, 1185, 1019],
                    '48': [1875, 1745, 1615, 1485, 1354, 1224, 1094],
                    '60': [1763, 1654, 1545, 1436, 1327, 1219, 1110]
                };

            }
            if (pathName.includes('baic-3')) {
                var leasingHRVTable = {
                    '24': [1442, 1295, 1148, 1001, 854, 707, 560],
                    '36': [1197, 1094, 999, 889, 787, 684, 582],
                    '48': [1157, 1077, 996, 916, 835, 755, 675],
                    '60': [1087, 1020, 953, 886, 819, 752, 685]
                };

            }



            $('#monthsHRV').on('input', function() {
                $('#monthsHRVValue').text($(this).val());
                getMonthlyPayment(result, leasingHRVTable, $('#monthsHRV').val(), $('#downPaymentHRV').val());
                const monthsValue = $('#monthsHRV').val();
                const kmLimits = {
                    "24": "50 000 KM",
                    "36": "75 000 KM",
                    "48": "100 000 KM",
                    "60": "100 000 KM"
                };

                if (pathName.includes('baic-3')) {
                    var priceGapTable = {
                        "24": "610",
                        "36": "407",
                        "48": "1085",
                        "60": "723"
                    };
                }
                if (pathName.includes('baic-5')) {
                    var priceGapTable = {
                        "24": "750",
                        "36": "500",
                        "48": "620",
                        "60": "496"
                    };
                }
                if (pathName.includes('baic-7')) {
                    var priceGapTable = {
                        "24": "930",
                        "36": "620",
                        "48": "748",
                        "60": "598"
                    };
                }

                if (kmLimits.hasOwnProperty(monthsValue)) {
                    $('#kmLimitHRVValue').text(kmLimits[monthsValue]);
                }

                if (priceGapTable.hasOwnProperty(monthsValue)) {
                    $('#priceGap').text(priceGapTable[monthsValue]);
                }

            });
            $('#downPaymentHRV').on('input', function() {
                $('#downPaymentHRVValue').text($(this).val() + '%');
                getMonthlyPayment(result, leasingHRVTable, $('#monthsHRV').val(), $('#downPaymentHRV').val());
            });
            getMonthlyPayment(result, leasingHRVTable, $('#monthsHRV').val(), $('#downPaymentHRV').val());
        }
    }

    function toCountStandart() {
        var pathName = window.location.pathname;
        if ($('#calculateRateStandart').hasClass('open')) {
            var result = $('#monthlyPaymentStandart');

            if (pathName.includes('baic-7')) {
                var leasingStandartTable = {
                    "24": [5397, 5093, 4790, 4486, 4182, 3879, 3575],
                    "30": [4841, 4593, 4344, 4096, 3847, 3599, 3351],
                    "36": [4328, 4116, 3904, 3693, 3481, 3269, 3058],
                    "42": [3794, 3608, 3423, 3237, 3052, 2866, 2681],
                    "48": [3394, 3228, 3062, 2896, 2731, 2565, 2399],
                    "54": [3084, 2934, 2783, 2632, 2481, 2331, 2180],
                    "60": [2837, 2699, 2560, 2421, 2283, 2144, 2006]
                };

            }
            if (pathName.includes('baic-5')) {
                var leasingStandartTable = {
                    "24": [4234, 3999, 3761, 3522, 3284, 3045, 2807],
                    "30": [3801, 3606, 3411, 3216, 3021, 2826, 2631],
                    "36": [3398, 3232, 3066, 2899, 2733, 2567, 2401],
                    "42": [2979, 2833, 2687, 2542, 2396, 2250, 2105],
                    "48": [2665, 2535, 2404, 2274, 2144, 2014, 1883],
                    "54": [2422, 2303, 2185, 2067, 1948, 1830, 1712],
                    "60": [2228, 2119, 2010, 1901, 1792, 1683, 1575]
                };


            }
            if (pathName.includes('baic-3')) {
                var leasingStandartTable = {
                    "24": [2614, 2467, 2320, 2173, 2026, 1879, 1732],
                    "30": [2345, 2224, 2104, 1984, 1863, 1743, 1623],
                    "36": [2096, 1994, 1891, 1789, 1686, 1584, 1481],
                    "42": [1837, 1748, 1658, 1568, 1478, 1388, 1298],
                    "48": [1644, 1564, 1483, 1403, 1323, 1242, 1162],
                    "54": [1494, 1421, 1348, 1275, 1202, 1129, 1056],
                    "60": [1374, 1307, 1240, 1173, 1106, 1038, 971]
                };


            }
            $('#monthsStandart').on('input', function() {
                $('#monthsStandartValue').text($(this).val());
                getMonthlyPayment(result, leasingStandartTable, $('#monthsStandart').val(), $('#downPaymentStandart').val());
                const buyOutCost = {
                    "24": "17%",
                    "30": "7%",
                    "36": "1%",
                    "42": "1%",
                    "48": "1%",
                    "54": "1%",
                    "60": "1%"
                };
                const monthsValue = $('#monthsStandart').val();
                if (buyOutCost.hasOwnProperty(monthsValue)) {
                    $('#buyOut').text(buyOutCost[monthsValue]);
                }

                if (pathName.includes('baic-3')) {
                    var gapTableStandart = {
                        "24": "610",
                        "30": "488",
                        "36": "407",
                        "42": "620",
                        "48": "543",
                        "54": "482",
                        "60": "434"
                    };
                }
                if (pathName.includes('baic-5')) {
                    var gapTableStandart = {
                        "24": "750",
                        "30": "600",
                        "36": "500",
                        "42": "709",
                        "48": "620",
                        "54": "551",
                        "60": "496"
                    };
                }
                if (pathName.includes('baic-7')) {
                    var gapTableStandart = {
                        "24": "930",
                        "30": "744",
                        "36": "620",
                        "42": "829",
                        "48": "725",
                        "54": "644",
                        "60": "580"
                    };
                }
                if (gapTableStandart.hasOwnProperty(monthsValue)) {
                    $('#priceGapStandart').text(gapTableStandart[monthsValue]);
                }

            });
            $('#downPaymentStandart').on('input', function() {
                $('#downPaymentStandartValue').text($(this).val() + '%');
                getMonthlyPayment(result, leasingStandartTable, $('#monthsStandart').val(), $('#downPaymentStandart').val());
            });
            getMonthlyPayment(result, leasingStandartTable, $('#monthsStandart').val(), $('#downPaymentStandart').val());
        }
    }


    function toCountCredit() {
        var pathName = window.location.pathname;
        if ($('#calculateRateCredit').hasClass('open')) {
            var result = $('#monthlyPaymentCredit');
            var rateResult = $('#monthlyRRSOCredit');


            if (pathName.includes('baic-7')) {
                var CreditTable = {

                    24: ["4501 , 12,55", "4098 , 12,50", "3696 , 12,45", "3294 , 12,39", "2891 , 12,33", "2489 , 12,27", "2086 , 12,20"],
                    36: ["3704 , 11,69", "3428 , 11,66", "3152 , 11,63", "2876 , 11,60", "2600 , 11,57", "2324 , 11,53", "2048 , 11,50"],
                    48: ["3144 , 11,21", "2930 , 11,20", "2715 , 11,18", "2501 , 11,16", "2287 , 11,14", "2073 , 11,12", "1858 , 11,09"],
                    60: ["2913 , 10,98", "2735 , 10,98", "2557 , 10,97", "2380 , 10,96", "2202 , 10,95", "2024 , 10,94", "1736 , 11,89"]

                };
            }
            if (pathName.includes('baic-5')) {
                var CreditTable = {

                    24: ["3537 , 12,59", "3221 , 12,54", "2905 , 12,49", "2589 , 12,44", "2273 , 12,38", "1957 , 12,32", "1641 , 12,25"],
                    36: ["2911 , 11,73", "2695 , 11,71", "2478 , 11,68", "2261 , 11,65", "2045 , 11,62", "1828 , 11,59", "1611 , 11,55"],
                    48: ["2472 , 11,26", "2303 , 11,24", "2135 , 11,23", "1967 , 11,21", "1799 , 11,19", "1630 , 11,17", "1462 , 11,15"],
                    60: ["2290 , 11,03", "2151 , 11,02", "2011 , 11,02", "1872 , 11,01", "1732 , 11,00", "1592 , 11,00", "1453 , 10,99"]

                };
            }
            if (pathName.includes('baic-3')) {
                var CreditTable = {

                    24: ["2188 , 12,71", "1993 , 12,67", "1798 , 12,62", "1 603 , 12,58", "1408 , 12,52", "1213 , 12,47", "1018 , 12,41"],
                    36: ["1802 , 11,86", "1668 , 11,84", "1534 , 11,82", "1 401 , 11,80", "1267 , 11,77", "1133 , 11,75", "1000 , 11,72"],
                    48: ["1530 , 11,39", "1427 , 11,38", "1323 , 11,37", "1 219 , 11,36", "1115 , 11,35", "1012 , 11,33", "908 , 11,32"],
                    60: ["1419 , 11,17", "1333 , 11,17", "1246 , 11,17", "1 160 , 11,17", "1074 , 11,17", "988 , 11,17", "902 , 11,17"]

                };
            }

            $('#monthsCredit').on('input', function() {
                $('#monthsCreditValue').text($(this).val());
                getMonthlyPaymentCredit(result, rateResult, CreditTable, $('#monthsCredit').val(), $('#downPaymentCredit').val());

                const monthsValue = $('#monthsCredit').val();

                if (pathName.includes('baic-3')) {
                    var priceGapTable = {
                        "24": "610",
                        "36": "407",
                        "48": "543",
                        "60": "434"
                    };
                }
                if (pathName.includes('baic-5')) {
                    var priceGapTable = {
                        "24": "750",
                        "36": "500",
                        "48": "620",
                        "60": "496"
                    };
                }
                if (pathName.includes('baic-7')) {
                    var priceGapTable = {
                        "24": "930",
                        "36": "620",
                        "48": "725",
                        "60": "580"
                    };
                }
                if (priceGapTable.hasOwnProperty(monthsValue)) {
                    $('#priceGapCredit').text(priceGapTable[monthsValue]);
                }

            });
            $('#downPaymentCredit').on('input', function() {
                $('#downPaymentCreditValue').text($(this).val() + '%');
                getMonthlyPaymentCredit(result, rateResult, CreditTable, $('#monthsCredit').val(), $('#downPaymentCredit').val());
            });
            getMonthlyPaymentCredit(result, rateResult, CreditTable, $('#monthsCredit').val(), $('#downPaymentCredit').val());
        }
    }

    function toCountLoan() {
        var pathName = window.location.pathname;
        if ($('#calculateRateLoan').hasClass('open')) {
            var result = $('#monthlyPaymentLoan');
            var rateResult = $('#monthlyRRSOLoan');


            if (pathName.includes('baic-7')) {
                var LoanTable = {




                    24: ["7755 , 13,96", "7368 , 13,98", "6981 , 13,99", "6594 , 14,00", "6207 , 14,02", "5820 , 14,04", "5433 , 14,06"],
                    36: ["5399 , 12,52", "5130 , 12,53", "4861 , 12,54", "4592 , 12,56", "4322 , 12,57", "4053 , 12,59", "3784 , 12,61"],
                    48: ["4226 , 11,79", "4015 , 11,80", "3805 , 11,81", "3594 , 11,82", "3383 , 11,84", "3173 , 11,86", "2962 , 11,88"],
                    60: ["3525 , 11,34", "3350 , 11,35", "3174 , 11,37", "2999 , 11,38", "2823 , 11,40", "2648 , 11,41", "2472 , 11,43"],
                    72: ["3061 , 11,05", "2909 , 11,06", "2756 , 11,07", "2604 , 11,08", "2452 , 11,10", "2300 , 11,11", "2147 , 11,13"],
                    84: ["2732 , 10,83", "2596 , 10,84", "2460 , 10,86", "2325 , 10,87", "2189 , 10,88", "2053 , 10,90", "1917 , 10,92"],
                    96: ["2488 , 10,67", "2364 , 10,68", "2240 , 10,69", "2117 , 10,71", "1993 , 10,72", "1870 , 10,74", "1746 , 10,75"]
                };
            }
            if (pathName.includes('baic-5')) {
                var LoanTable = {
                    24: ["6092 , 14,02", "5789 , 14,04", "5485 , 14,06", "5181 , 14,07", "4877 , 14,09", "4573 , 14,12", "4269 , 14,15"],
                    36: ["4242 , 12,58", "4031 , 12,59", "3820 , 12,61", "3608 , 12,63", "3397 , 12,65", "3186 , 12,67", "2974 , 12,70"],
                    48: ["3321 , 11,84", "3156 , 11,86", "2990 , 11,87", "2825 , 11,89", "2660 , 11,91", "2494 , 11,93", "2329 , 11,96"],
                    60: ["2771 , 11,40", "2633 , 11,41", "2495 , 11,43", "2358 , 11,45", "2220 , 11,49", "2082 , 11,49", "1944 , 11,51"],
                    72: ["2407 , 11,10", "2287 , 11,11", "2167 , 11,13", "2048 , 11,15", "1928 , 11,16", "1809 , 11,19", "1689 , 11,21"],
                    84: ["2148 , 10,89", "2042 , 10,90", "1935 , 10,91", "1828 , 10,93", "1722 , 10,95", "1615 , 10,97", "1508 , 10,99"],
                    96: ["1956 , 10,73", "1859 , 10,74", "1762 , 10,75", "1665 , 10,77", "1568 , 10,79", "1471 , 10,81", "1374 , 10,83"]



                };
            }
            if (pathName.includes('baic-3')) {
                var LoanTable = {
                    24: ["3764 , 14,20", "3577 , 14,22", "3389 , 14,25", "3202 , 14,28", "3014 , 14,31", "2827 , 14,35", "2639 , 14,39"],
                    36: ["2623 , 12,75", "2492 , 12,77", "2362 , 12,80", "2232 , 12,83", "2101 , 12,86", "1971 , 12,90", "1840 , 12,94"],
                    48: ["2054 , 12,01", "1952 , 12,03", "1850 , 12,06", "1748 , 12,09", "1647 , 12,12", "1545 , 12,15", "1443 , 12,20"],
                    60: ["1715 , 11,56", "1630 , 11,58", "1545 , 11,61", "1460 , 11,64", "1375 , 11,67", "1290 , 11,70", "1205 , 11,74"],
                    72: ["1490 , 11,26", "1417 , 11,28", "1343 , 11,30", "1269 , 11,33", "1195 , 11,36", "1122 , 11,40", "1048 , 11,44"],
                    84: ["1331 , 11,04", "1265 , 11,06", "1199 , 11,09", "1134 , 11,11", "1068 , 11,14", "1002 , 11,17", "936 , 11,21"],
                    96: ["1213 , 10,88", "1153 , 10,90", "1093 , 10,92", "1033 , 10,94", "973 , 10,97", "913 , 11,01", "853 , 11,04"]



                };
            }

            $('#monthsLoan').on('input', function() {
                $('#monthsLoanValue').text($(this).val());
                getMonthlyPaymentCredit(result, rateResult, LoanTable, $('#monthsLoan').val(), $('#downPaymentLoan').val());

                const monthsValue = $('#monthsLoan').val();

                if (pathName.includes('baic-3')) {
                    var priceGapTable = {
                        "24": "610",
                        "36": "407",
                        "48": "543",
                        "60": "434",
                        "72": "nie dotyczy",
                        "84": "nie dotyczy",
                        "96": "nie dotyczy"
                    };
                }
                if (pathName.includes('baic-5')) {
                    var priceGapTable = {
                        "24": "750",
                        "36": "500",
                        "48": "620",
                        "60": "496",
                        "72": "nie dotyczy",
                        "84": "nie dotyczy",
                        "96": "nie dotyczy"
                    };
                }
                if (pathName.includes('baic-7')) {
                    var priceGapTable = {
                        "24": "930",
                        "36": "620",
                        "48": "725",
                        "60": "580",
                        "72": "nie dotyczy",
                        "84": "nie dotyczy",
                        "96": "nie dotyczy"
                    };
                }
                if (priceGapTable.hasOwnProperty(monthsValue)) {
                    $('#priceGapLoan').text(priceGapTable[monthsValue]);
                }


            });
            $('#downPaymentLoan').on('input', function() {
                $('#downPaymentLoanValue').text($(this).val() + '%');
                getMonthlyPaymentCredit(result, rateResult, LoanTable, $('#monthsLoan').val(), $('#downPaymentLoan').val());
            });
            getMonthlyPaymentCredit(result, rateResult, LoanTable, $('#monthsLoan').val(), $('#downPaymentLoan').val());
        }
    }

});
